/**
 * @param {String[]} props
 * @returns {Function}
 */
export default function excludeProps(...props) {
  const set = new Set(props);
  return (prop) => !set.has(prop);
}
